import React, { useState, useEffect } from "react";
import { Table, TableHeader, TableColumn, TableBody, TableRow, TableCell, Chip, Spinner, Card, CardBody } from "@heroui/react";
import { apiClientExporter } from "../../services/apiClient";
import { format } from "date-fns";

const AuditLogTab = ({ maestraData }) => {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchLogs = async () => {
            if (!maestraData?.id) return;
            
            setLoading(true);
            try {
                // Asumimos que la tabla es 'maestra_recuperos' y el ID es el de maestraData
                const response = await apiClientExporter.get(`/exporter/audit/logs/maestra_recuperos/${maestraData.id}`);
                setLogs(response.data);
            } catch (err) {
                console.error("Error fetching audit logs:", err);
                setError("Failed to load audit logs");
            } finally {
                setLoading(false);
            }
        };

        fetchLogs();
    }, [maestraData]);

    const formatChanges = (changes) => {
        if (!changes || Object.keys(changes).length === 0) return "No specific changes recorded";
        
        return (
            <div className="flex flex-col gap-2">
                {Object.entries(changes).map(([key, value]) => (
                    <div key={key} className="text-small">
                        <span className="font-semibold text-primary">{key}:</span>{" "}
                        <span className="text-gray-500 line-through mr-1">{String(value.old)}</span>
                        <span className="text-gray-500 mr-1">→</span>
                        <span className="font-bold text-success">{String(value.new)}</span>
                    </div>
                ))}
            </div>
        );
    };

    if (loading) {
        return (
            <div className="flex justify-center items-center p-8">
                <Spinner label="Loading history..." color="primary" />
            </div>
        );
    }

    if (error) {
        return <div className="text-red-500 p-4 text-center">{error}</div>;
    }

    if (logs.length === 0) {
        return (
            <Card>
                <CardBody className="text-center p-8 text-gray-500">
                    <p>No changes recorded for this case yet.</p>
                </CardBody>
            </Card>
        );
    }

    return (
        <div className="flex flex-col gap-4">
            <h3 className="text-lg font-semibold">Change History</h3>
            <Table aria-label="Audit Log Table" isStriped>
                <TableHeader>
                    <TableColumn>DATE</TableColumn>
                    <TableColumn>USER</TableColumn>
                    <TableColumn>ACTION</TableColumn>
                    <TableColumn>CHANGES</TableColumn>
                </TableHeader>
                <TableBody>
                    {logs.map((log) => (
                        <TableRow key={log.id}>
                            <TableCell className="whitespace-nowrap align-top">
                                {format(new Date(log.changed_at), "dd/MM/yyyy HH:mm:ss")}
                            </TableCell>
                            <TableCell className="align-top">
                                <Chip size="sm" variant="flat" color="secondary">
                                    {log.changed_by?.replace('user:', '') || 'Unknown'}
                                </Chip>
                            </TableCell>
                            <TableCell className="align-top">
                                <Chip 
                                    size="sm" 
                                    color={log.action === 'INSERT' ? 'success' : log.action === 'UPDATE' ? 'primary' : 'danger'}
                                    variant="dot"
                                >
                                    {log.action}
                                </Chip>
                            </TableCell>
                            <TableCell>
                                {formatChanges(log.changes)}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </div>
    );
};

export default AuditLogTab;
